import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FeatureFlag } from '../dto/feature-flag';
import { CompanyFiscalType } from '../model/company-fiscal-type.enum';
import * as fromCompanySettingsStore from '../store/index';

@Injectable()
export class CompanySettingsServiceHelper {
  private _aliases: Object = {
    us: [
      'us',
      'united states east coast',
      'united states west coast',
      'united states of america',
      'united states',
      'usa'
    ],
    uk: ['uk', 'united kingdom']
  };

  constructor(private store: Store<fromCompanySettingsStore.CompanyState>) {}

  public isCompanyIn(country: string): Observable<boolean> {
    return fromCompanySettingsStore
      .getPropertyFromSettingsStore(this.store, 'country')
      .pipe(
        map((countryFromSettings: string) => {
          if (this._aliases[country]) {
            return (
              this._aliases[country].indexOf(
                (countryFromSettings || '').toLowerCase()
              ) > -1
            );
          } else {
            return (
              (countryFromSettings || '').toUpperCase() ===
              country.toUpperCase()
            );
          }
        })
      );
  }

  public isBlackboxAccount(): Observable<boolean> {
    return fromCompanySettingsStore
      .getPropertyFromSettingsStore(this.store, 'type')
      .pipe(
        map((companyType: CompanyFiscalType) => {
          return companyType === CompanyFiscalType.BLACKBOX;
        })
      );
  }

  public isBlackboxV2Account(): Observable<boolean> {
    return fromCompanySettingsStore
      .getPropertyFromSettingsStore(this.store, 'type')
      .pipe(
        map((companyType: CompanyFiscalType) => {
          return companyType === CompanyFiscalType.BLACKBOX2;
        })
      );
  }

  public isMenuFeatureEnabled(): Observable<boolean> {
    return fromCompanySettingsStore
      .getPropertyFromSettingsStore(this.store, 'featureFlagMenuManagement')
      .pipe(
        map(
          (feature: string) =>
            feature === FeatureFlag.ENABLED ||
            feature === FeatureFlag.INTERNAL ||
            feature === undefined
        )
      );
  }

  public getDecimalFormat(): Observable<{
    numberOfDecimals: number;
    locale: string;
  }> {
    return combineLatest(
      fromCompanySettingsStore.getPropertyFromSettingsStore(
        this.store,
        'numberOfDecimals'
      ),
      fromCompanySettingsStore.getPropertyFromSettingsStore(
        this.store,
        'locale'
      )
    ).pipe(
      map((data: [number, string]) => {
        return {
          numberOfDecimals: data[0],
          locale: data[1]
        };
      })
    );
  }
}
